export default "__VITE_ASSET__10abd5ad__"